export function getContinuationStartIndex(previousSceneCount: number, nextSceneCount: number) {
  return nextSceneCount > previousSceneCount ? previousSceneCount : null;
}

export type ReaderSceneRef = { index: number };

export function resolveReaderIndex(savedSceneIndex: number | null, scenes: ReaderSceneRef[]) {
  if (!scenes.length || savedSceneIndex === null || !Number.isInteger(savedSceneIndex)) return 0;

  const exact = scenes.findIndex((scene) => scene.index === savedSceneIndex);
  if (exact >= 0) return exact;

  let nearestEarlier = 0;
  scenes.forEach((scene, index) => {
    if (scene.index <= savedSceneIndex) nearestEarlier = index;
  });
  return nearestEarlier;
}

export function resolveReaderStartIndex(requestedSceneIndex: number | undefined, savedSceneIndex: number | null, scenes: ReaderSceneRef[]) {
  const targetSceneIndex = Number.isInteger(requestedSceneIndex) ? requestedSceneIndex : savedSceneIndex;
  return resolveReaderIndex(targetSceneIndex ?? null, scenes);
}

const READER_POSITION_PREFIX = 'storyweave:reader-position:';

export function readReaderPosition(projectId: string) {
  try {
    const value = Number.parseInt(localStorage.getItem(`${READER_POSITION_PREFIX}${projectId}`) || '', 10);
    return Number.isInteger(value) && value > 0 ? value : null;
  } catch {
    return null;
  }
}

export function saveReaderPosition(projectId: string, sceneIndex: number) {
  try {
    localStorage.setItem(`${READER_POSITION_PREFIX}${projectId}`, String(sceneIndex));
  } catch {
    // Private browsing or a disabled storage API should not block reading.
  }
}

export function clearReaderPosition(projectId: string) {
  try {
    localStorage.removeItem(`${READER_POSITION_PREFIX}${projectId}`);
  } catch {
    // A disabled storage API should not block the deleted-project flow.
  }
}
